import { lazy } from 'react'

import {
  emailMessageProfilePrintDataLoader,
  emailMessageProfileRawDataLoader,
  emailThreadProfilePrintDataLoader,
} from '../components/Email'
import { RouteErrorPage } from '../components/ErrorPage'
import { Loader } from '../components/Loader'
import { ROUTE_PARAM_MAIL_UUID, ROUTE_PATH_LIST } from '../constants/route'
import { getUuidParamGuardLoader } from '../utils/route'

const EmailMessageProfileRaw = lazy(() =>
  import('../components/Email/EmailMessageProfileRaw').then(m => ({
    default: m.EmailMessageProfileRaw,
  }))
)
const EmailMessageProfilePrint = lazy(() =>
  import('../components/Email/EmailMessageProfilePrint').then(m => ({
    default: m.EmailMessageProfilePrint,
  }))
)
const EmailThreadProfilePrint = lazy(() =>
  import('../components/Email/EmailThreadProfilePrint').then(m => ({
    default: m.EmailThreadProfilePrint,
  }))
)

export function getEmailRawRoutes() {
  return [
    {
      HydrateFallback: Loader,
      element: <EmailMessageProfileRaw />,
      errorElement: <RouteErrorPage />,
      loader: getUuidParamGuardLoader({
        loader: emailMessageProfileRawDataLoader,
        paramName: ROUTE_PARAM_MAIL_UUID,
      }),
      path: `/${ROUTE_PATH_LIST.mails}/${ROUTE_PATH_LIST.mailMessageRaw}`,
    },
    {
      HydrateFallback: Loader,
      element: <EmailMessageProfilePrint />,
      errorElement: <RouteErrorPage />,
      loader: getUuidParamGuardLoader({
        loader: emailMessageProfilePrintDataLoader,
        paramName: ROUTE_PARAM_MAIL_UUID,
      }),
      path: `/${ROUTE_PATH_LIST.mails}/${ROUTE_PATH_LIST.mailMessagePrint}`,
    },
    {
      HydrateFallback: Loader,
      element: <EmailThreadProfilePrint />,
      errorElement: <RouteErrorPage />,
      loader: getUuidParamGuardLoader({
        loader: emailThreadProfilePrintDataLoader,
        paramName: ROUTE_PARAM_MAIL_UUID,
      }),
      path: `/${ROUTE_PATH_LIST.mails}/${ROUTE_PATH_LIST.mailThreadPrint}`,
    },
  ]
}
